// https://api.myokr.ir/api/Tenant/GetAllTenantsInfo
import axiosInstance from "../../../Axios/Axios"

const getAllTenantsInfo=async()=>{
return await axiosInstance.get('Tenant/GetAllTenantsInfo')
}

const getTenants = async (phoneNumber: any) => {
    // let meetingId:any=queryKey[1];
    return await axiosInstance.post(`/Tenant/GetAllTenantByPhoneNumber?phoneNumber=${phoneNumber}`);
  };

export {
    getAllTenantsInfo,
    getTenants
}